/** Date/time formatting for the chat surface (WhatsApp-style). Kept tiny and
 * local — the only consumers are the conversation list + the thread. */

function safe(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** A clock time for a message bubble, e.g. "2:34 PM". */
export function messageTime(iso: string): string {
  const d = safe(iso);
  return d ? d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }) : "";
}

/** Have two timestamps the same calendar day? */
export function sameDay(a: string, b: string): boolean {
  const da = safe(a);
  const db = safe(b);
  return !!da && !!db && startOfDay(da) === startOfDay(db);
}

/** A day-divider label: "Today" / "Yesterday" / "Mon, Jun 2". */
export function dayDividerLabel(iso: string): string {
  const d = safe(iso);
  if (!d) return "";
  const today = startOfDay(new Date());
  const day = startOfDay(d);
  const oneDay = 86_400_000;
  if (day === today) return "Today";
  if (day === today - oneDay) return "Yesterday";
  return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

/** WhatsApp conversation-list timestamp: time if today, "Yesterday", a
 * weekday within the last week, else a short date. Empty for no message. */
export function listTimestamp(iso: string | null): string {
  const d = safe(iso);
  if (!d) return "";
  const today = startOfDay(new Date());
  const day = startOfDay(d);
  const oneDay = 86_400_000;
  if (day === today) return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  if (day === today - oneDay) return "Yesterday";
  if (today - day < 7 * oneDay) return d.toLocaleDateString(undefined, { weekday: "short" });
  return d.toLocaleDateString(undefined, { month: "numeric", day: "numeric", year: "2-digit" });
}
